import { NavLink, Outlet, useLocation } from 'react-router';
import { CalendarDays, House, QrCode, ShoppingBag, UserRound } from 'lucide-react';
import { useTenant } from '../lib/tenant';
import { useAppConfig } from '../lib/queries';
import { useReservationSettings } from '../lib/reservations';
import { cx } from './kit';
import { UpdateBanner } from './update';

/**
 * Uygulama kabuğu: içerik + cam efektli alt sekme çubuğu. Ortadaki karekod düğmesi kasada kimlik/ödeme içindir
 * (en sık iş: kasada okutmak). Rezervasyon sekmesi işletme rezervasyonu açtıysa görünür.
 */
export function AppShell() {
  const { path } = useTenant();
  const { data: config } = useAppConfig();
  const loc = useLocation();
  const features = config?.profile.features as Record<string, boolean> | undefined;
  // Rezervasyon sekmesi: işletme en az bir şubede açtıysa (bilinene kadar göster — kayma olmasın).
  const reservations = useReservationSettings().data?.enabled !== false;
  const ordering = features?.mobileOrder !== false;

  const tabs = [
    { to: path(), label: 'Ana Sayfa', icon: House, end: true },
    { to: path('siparis'), label: ordering ? 'Sipariş' : 'Menü', icon: ShoppingBag },
    { to: path('kod'), label: 'Karekod', icon: QrCode, center: true },
    ...(reservations ? [{ to: path('rezervasyon'), label: 'Rezervasyon', icon: CalendarDays }] : []),
    { to: path('hesap'), label: 'Hesabım', icon: UserRound },
  ];

  return (
    <div className="mx-auto min-h-dvh max-w-xl">
      <UpdateBanner />
      <main key={loc.pathname.split('/').slice(0, 3).join('/')} className="animate-fade pb-[calc(88px+env(safe-area-inset-bottom))]">
        <Outlet />
      </main>
      <nav aria-label="Ana gezinme" className="glass fixed inset-x-0 bottom-0 z-40 border-t border-line/60 pb-safe">
        <ul className="mx-auto flex h-[68px] max-w-xl items-stretch px-2">
          {tabs.map((t) => (
            <li key={t.label} className="flex flex-1 justify-center">
              <NavLink
                to={t.to}
                end={t.end}
                className={({ isActive }) =>
                  cx(
                    'group flex w-full flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors',
                    isActive ? 'text-brand' : 'text-muted',
                  )
                }
              >
                {({ isActive }) =>
                  t.center ? (
                    <>
                      <span className={cx('-mt-6 grid size-14 place-items-center rounded-2xl shadow-float ring-4 ring-bg transition-transform group-active:scale-95', isActive ? 'gold-fill' : 'card-emerald')}>
                        <t.icon className="size-6" strokeWidth={2.2} />
                      </span>
                      <span className={cx(isActive ? 'text-ink' : 'text-muted')}>{t.label}</span>
                    </>
                  ) : (
                    <>
                      <t.icon className="size-[22px]" strokeWidth={isActive ? 2.4 : 1.9} />
                      <span>{t.label}</span>
                    </>
                  )
                }
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
